import { defineComponent as _defineComponent } from 'vue'
import { storeToRefs } from 'pinia';
import CardParametrosConsulta from './components/consulta/CardParametrosConsulta.vue';
import ResultadoConsulta from './components/consulta/ResultadoConsulta.vue';
import { ConsultaBoletinsStore } from './store/ConsultaBoletinsStore';
import HeaderCustom from '../components/HeaderCustom.vue';
import { onMounted } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'ConsultaBoletins',
  setup(__props) {

const store = ConsultaBoletinsStore();

const { totalElementos } = storeToRefs(store);

onMounted(async () => {
  store.buscaInicialBoletins();
});

return { __sfc: true,store, totalElementos, CardParametrosConsulta, ResultadoConsulta, HeaderCustom }
}

})